export default __webpack_public_path__ + "static/media/masa-gray.9ad61189.svg";